module.exports = __webpack_public_path__ + "static/media/Heatmor_gaussian2.87a0f814.png";